import { combineReducers } from '@reduxjs/toolkit';
import getReminderListReducer from './get-reminder-list';
import updateReminderReducer from './update-reminder';
import updateReminderEmailListReducer from './update-reminder-email-list';

const reminderReducer = combineReducers({
  getReminderList: getReminderListReducer,
  updateReminder: updateReminderReducer,
  updateReminderEmailList: updateReminderEmailListReducer
});

export default reminderReducer;